import GridPage from "components/layout/GridPage";
import { Box, Typography } from "@mui/material";
import useIsMobile from "components/hooks/useIsMobile";
import { Bot } from "lucide-react";
import FlexBox from "components/common/FlexBox";
import ToolDemo from "components/tools/ToolDemo";

export default () => {
  const isMobile = useIsMobile();

  return (
    <GridPage
      sx={{
        margin: isMobile ? "" : "64px auto",
        maxWidth: "800px",
        padding: isMobile ? "20px" : "0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          alignItems: isMobile ? "flex-start" : "center",
          marginBottom: "24px",
          gap: "12px",
        }}
      >
        <FlexBox direction="column" gap="8px">
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Bot
              color="#198282"
              height="24px"
              width="24px"
              style={{ marginRight: "8px" }}
            />
            <Typography variant="title">Agent Demo</Typography>
          </Box>
          <Typography variant="body">
            Test the Faye agent with different scenarios and parameters.
          </Typography>
        </FlexBox>
      </Box>
      <ToolDemo />
    </GridPage>
  );
};
